
import { Header } from "@/components/Header";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-24 pb-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
          
          <div className="space-y-6 text-gray-700">
            <div className="mb-4">
              <p className="text-sm mb-2">
                Effective Date: 08/02/2025<br />
                Last Updated: 08/02/2025
              </p>
              <p className="mb-4">
                Welcome to DubCity AI Solutions! By accessing or using our services, you agree to the following Terms of Service. 
                Please read them carefully. If you do not agree with any part of these terms, you may not use our services.
              </p>
            </div>

            <section>
              <h2 className="text-xl font-semibold mb-3">1. Definitions</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>"We," "Us," or "Our" refers to DubCity AI Solutions.</li>
                <li>"You" or "Client" refers to the individual or entity using our services.</li>
                <li>"Services" refers to the AI solutions, consultations, and any related products or features we offer.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. Acceptance of Terms</h2>
              <p>
                By using our services, you confirm that you are at least 18 years old and legally capable of entering into a binding agreement.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. Scope of Services</h2>
              <p>
                We provide tailored AI solutions, consultations, and technical support to help businesses automate processes, 
                improve workflows, and achieve their goals. Details of specific services will be outlined in individual 
                agreements or project scopes.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. User Responsibilities</h2>
              <p className="mb-2">You agree to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide accurate information during onboarding and throughout the service period.</li>
                <li>Comply with all applicable laws and regulations when using our services.</li>
                <li>Not misuse, resell, or modify our services without prior written consent.</li>
                <li>Ensure that any data or content you provide does not infringe on third-party rights.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Fees and Payment</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Fees for services will be agreed upon in individual contracts or invoices.</li>
                <li>Payments are due as specified in the agreement.</li>
                <li>Late payments may result in service interruptions or additional fees.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">6. Intellectual Property Rights</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>We retain ownership of all AI models, software, and intellectual property developed during service delivery, unless otherwise agreed.</li>
                <li>You will retain ownership of any proprietary data or content provided by you.</li>
                <li>You are granted a limited, non-transferable license to use deliverables as specified in the project agreement.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">7. Confidentiality</h2>
              <p>
                Both parties agree to protect each other's confidential information and not disclose it to third parties 
                without prior written consent. Confidential information includes business plans, technical data, and any 
                proprietary details.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">8. Data Privacy</h2>
              <p>
                We respect your privacy and handle data according to our{" "}
                <Link to="/privacy-policy" className="text-primary hover:underline">
                  Privacy Policy
                </Link>. 
                By using our services, you agree that we may collect and use certain information to provide better services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">9. Termination</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Either party may terminate the agreement with prior written notice as specified in the project contract.</li>
                <li>We reserve the right to terminate or suspend access to services if you breach these terms.</li>
                <li>Upon termination, you must return or delete any proprietary materials belonging to us.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">10. Limitation of Liability</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>We are not liable for indirect, incidental, or consequential damages arising from the use of our services.</li>
                <li>Our total liability, in any case, will be limited to the amount paid by you for the service in question.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">11. Dispute Resolution</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Any disputes arising from these terms will be governed by the laws of New Zealand, with disputes resolved in the courts of Whangarei.</li>
                <li>Alternative dispute resolution methods may be agreed upon before legal action is pursued.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">12. Changes to the Terms</h2>
              <p>
                We reserve the right to update these terms at any time. Significant changes will be communicated to you 
                via email or posted on our website. Continued use of our services constitutes acceptance of the updated terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">13. Contact Information</h2>
              <p>For questions or concerns regarding these Terms of Service, please contact us:</p>
              <div className="mt-2">
                <p>DubCity AI Solutions</p>
                <p>Email: dubcityaisolutions@gmail.com</p>
                <p>Phone: 0221299230</p>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
